﻿package org.zq.pixelset.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

object PixelSetColors {
    val Primary = Color(0xFF2563EB)
    val PrimaryLight = Color(0xFFDBEAFE)
    val PrimaryContainer = Color(0xFFEFF6FF)
    val Background = Color(0xFFF3F4F6)
    val Surface = Color(0xFFFFFFFF)
    val SurfaceVariant = Color(0xFFF9FAFB)
    val Border = Color(0xFFE5E7EB)
    val BorderDashed = Color(0xFFD1D5DB)
    val TextPrimary = Color(0xFF111827)
    val TextSecondary = Color(0xFF6B7280)
    val TextMuted = Color(0xFF9CA3AF)
    val Success = Color(0xFF059669)
}

private val PixelSetColorScheme = lightColorScheme(
    primary = PixelSetColors.Primary,
    onPrimary = Color.White,
    primaryContainer = PixelSetColors.PrimaryContainer,
    onPrimaryContainer = PixelSetColors.Primary,
    background = PixelSetColors.Background,
    surface = PixelSetColors.Surface,
    onSurface = PixelSetColors.TextPrimary,
    onSurfaceVariant = PixelSetColors.TextSecondary,
    outline = PixelSetColors.Border,
)

@Composable
fun PixelSetTheme(content: @Composable () -> Unit) {
    MaterialTheme(
        colorScheme = PixelSetColorScheme,
        typography = pixelSetTypography(),
        content = content,
    )
}
